var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.item)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "ct",
              f_type: "title",
              is_disabled: false,
              f_title: _vm.__t("NAME"),
              f_val: _vm.cur_item.title,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("yes_no", {
            key: "group_type",
            attrs: { radio_options: _vm.group_types, title: "GROUP_TYPE" },
            on: {
              change: function ($event) {
                return _vm.change_atr("group_type", $event)
              },
            },
            model: {
              value: _vm.cur_item.group_type,
              callback: function ($$v) {
                _vm.$set(_vm.cur_item, "group_type", $$v)
              },
              expression: "cur_item.group_type",
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "ct_al",
              f_type: "alias",
              f_title: _vm.__t("ALIAS"),
              f_val: _vm.cur_item.alias,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "intro_html" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("INTRO_PROD_HTML")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-group flex-nowrap d-block" },
              [
                _c("vue-editor", {
                  attrs: { "editor-toolbar": _vm.editor_rules },
                  model: {
                    value: _vm.item.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "description", $$v)
                    },
                    expression: "item.description",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }